module.exports = __webpack_public_path__ + "img/banner_hk.61dc67b0.jpg";